/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLocaleConsentAcceptance} from '../api'

 export const useQueryGetLocaleConsentAcceptance = createReactQueryHook('getLocaleConsentAcceptance', getLocaleConsentAcceptance)
